import { createReducer } from '../../utils';
import * as Types from './types';
import { isServiceError } from '../../utils/errorCodes';

const initialState = {
  postingId: '',
  // Pueden ser: saveAndExit o saveAndContinue o preventExitModal
  triggerSource: null,
  errorOnSave: false,
  successOnSave: false,
  saving: false,
  errorOnSaveMessage: ''
};

const savePostingProfReducer = createReducer(initialState)({
  [Types.SAVE_POSTING_DB]: state => ({
    ...state,
    errorOnSave: false,
    saving: true
  }),
  [`${Types.SAVE_POSTING_DB}_COMPLETED`]: (state, action) => {
    return { ...state, postingId: action.payload.postingId, saving: false, successOnSave: true };
  },
  [`${Types.SAVE_POSTING_DB}_FAILED`]: (state, action) => ({
    ...state,
    saving: false,
    errorOnSave: isServiceError(action?.payload?.status),
    errorOnSaveMessage: action.payload?.data?.errorMessageCode
  }),
  [`${Types.SAVE_POSTING_DB}_CLEAR`]: state => ({
    ...state,
    triggerSource: null,
    errorOnSave: false,
    successOnSave: false,
    saving: false
  }),
  [`${Types.SAVE_POSTING_SET_SAVE_SOURCE}`]: (state, action) => ({
    ...state,
    triggerSource: action.payload.triggerSource
  }),
  [Types.SET_LOADING]: (state, action) => ({
    ...state,
    saving: action.payload.loading
  })
});

export { savePostingProfReducer };
